// Redigera texter och innehåll här. Strukturen är gjord för att enkelt kunna byggas på.
export const content = {
  brand: "Sundsvalls Bilpolare",
  since: "1999",
  hero: {
    kicker: "Bildelning i Sundsvall",
    lines: ["Dela bilen.", "Behåll", "friheten."],
    subtitle:
      "En lokal bilpool som funnits sedan 1999. Miljövänligt, ekonomiskt och enkelt – bilen finns när du behöver den, utan att du behöver äga den.",
    cta: "Bli medlem",
    ctaSecondary: "Så funkar det",
    image:
      "https://images.unsplash.com/photo-1572976592137-31e3fc9a817a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  marquee: ["Lokal", "Hållbar", "Prisvärd", "Miljövänlig", "Sedan 1999", "Gasdriven"],
  manifesto: {
    kicker: "Så funkar det",
    title: "Tre steg till en bil du delar",
    steps: [
      {
        n: "01",
        title: "Bli medlem",
        text: "Betala en insats och en låg årsavgift. Insatsen får du tillbaka om du väljer att lämna föreningen.",
      },
      {
        n: "02",
        title: "Boka bilen",
        text: "Boka enkelt via nätet, dygnet runt. Nycklar och bränslekort finns lättillgängligt för alla medlemmar.",
      },
      {
        n: "03",
        title: "Kör – och betala bara det du använder",
        text: "Räkningen för månadens resor kommer med e-post i slutet av månaden. Enklare kan det inte bli.",
      },
    ],
  },
  car: {
    kicker: "Föreningens bil",
    title: "Skoda Octavia",
    year: "2019",
    fuel: "Gas / Bensin",
    text: "Bränslesnål och välservad. När den inte är bokad står den i ett varmt garage mellan Tonhallen och NP3 Arena, centralt i Sundsvall.",
    specs: [
      "Cykelställ",
      "Bakåtvänd bilbarnstol & bilkudde",
      "Dragkrok",
      "Taklastare",
      "Kupévärmare",
    ],
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_sundsvall-carpool/artifacts/8jztdhdf_Skoda%20Oktavia%202019.png",
  },
  pricing: {
    kicker: "Priser",
    title: "Betala för det du kör – inget mer",
    join: [
      { label: "Insats (privatperson)", value: "4 000 kr", note: "Återbetalas när du lämnar föreningen" },
      { label: "Extra familjemedlem", value: "500 kr" },
      { label: "Insats (juridisk person)", value: "8 000 kr" },
      { label: "Medlemsavgift per år", value: "750 kr" },
    ],
    usage: [
      { label: "Timhyra (upp till 10 h)", value: "25 kr / tim" },
      { label: "Ett dygn", value: "250 kr" },
      { label: "Milkostnad (inkl. bränsle)", value: "25 kr / mil" },
      { label: "Bokningsavgift", value: "25 kr / bokning" },
    ],
  },
  student: {
    kicker: "Studenterbjudande",
    title: "Är du student vid MIUN?",
    text: "Medlemmar i Studentkåren vid Mittuniversitetet går med för en lägre insats – 1 000 kr istället för 4 000 kr. Erbjudandet gäller så länge du är medlem i Studentkåren.",
    highlight: "1 000 kr i insats",
    image:
      "https://images.unsplash.com/photo-1584278140365-2ab8bff2be82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  sustainability: {
    kicker: "Varför bildelning?",
    title: "Bättre för plånboken. Bättre för Sundsvall.",
    text: "När du bara använder bilen när du verkligen behöver den lär du dig snabbt att gå, cykla och åka kollektivt oftare. En delad bil ersätter många privata – mindre trängsel, mindre utsläpp, lägre kostnad.",
    stats: [
      { value: "1999", label: "Igång sedan" },
      { value: "~20", label: "Medlemmar idag" },
      { value: "1 → 2", label: "Bilar – med din hjälp" },
    ],
    image:
      "https://images.unsplash.com/photo-1528122819723-9dca3a31295d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  contact: {
    kicker: "Kontakt",
    title: "Vill du veta mer eller bli medlem?",
    people: [
      { name: "Lena Ericsson", email: "ericsson.31977@gmail.com", note: "Årsredovisning mejlas vid intresse" },
      { name: "Annika Ågebrant", email: "sundsvallsbilpolare@gmail.com" },
    ],
  },
};
